<template>
  <v-sheet color="transparent" width="100%" height="100%">
    <v-sheet
      color="transparent"
      width="100%"
      class="
        white--text
        text-h5 text-sm-h4 text-md-h3 text-lg-h2
        font-weight-bold
        text-center
        py-6 py-md-8 py-lg-12
        component-title
      "
    >
      PRODUTOS
    </v-sheet>

    <Loading v-if="loading" />

    <div v-else>
      <v-container class="pt-8 pb-10 pt-lg-12 pb-lg-16">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6">
            <Title
              class="d-block d-sm-none"
              :category="item.category.title"
              :center="false"
            >
              {{ item.title }}
            </Title>

            <v-sheet class="mb-6 mb-md-0 item-images">
              <zoom-on-hover
                :img-normal="`${imgHighlight}?resize=1&w=500`"
                :img-zoom="`${imgHighlight}?resize=1&w=800`"
                :scale="1.2"
                class="d-flex align-center justify-center item-image-highlight"
                v-if="imgHighlight"
              />

              <div v-if="images" class="mt-4 mt-md-0 justify-md-end">
                <Hooper
                  :settings="hooperSettings"
                  class="carousel-product-item"
                >
                  <Slide v-for="(img, key) in images" :key="key">
                    <v-btn
                      @mouseover="imgHighlight = img"
                      href="javascript:void(0);"
                      :class="
                        `pa-0 item-image-thumbnail` +
                        (imgHighlight === img ? ` active` : ``)
                      "
                      height="80px"
                      width="80px"
                      tile
                      depressed
                    >
                      <img
                        :src="`${img}?resize=1&w=65`"
                        :alt="item.title"
                        class="item-image"
                      />
                    </v-btn>
                  </Slide>
                </Hooper>
              </div>
            </v-sheet>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="mb-0 mb-sm-16 mb-md-0 pb-0 pb-sm-16 pb-md-0"
          >
            <Title
              class="d-none d-sm-block"
              :category="item.category.title"
              :center="false"
            >
              {{ item.title }}
            </Title>

            <div class="text-center text-sm-left">
              <v-btn
                color="#25d366"
                :href="whatsapp"
                v-if="whatsapp"
                height="auto"
                class="
                  white--text
                  text-body-1
                  font-weight-bold
                  text-none
                  mt-sm-7
                  py-3
                  px-7 px-md-10 px-lg-16
                "
                depressed
                rounded
              >
                <v-icon size="28" class="mr-3"> fa-whatsapp </v-icon>
                SOLICITAR ORÇAMENTO
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="item.text">
          <v-col cols="12">
            <div
              class="
                mt-8
                px-6 px-md-8
                py-8 py-sm-10 py-md-12 py-lg-14
                item-text
              "
            >
              <div
                class="
                  text-h6 text-sm-h5 text-lg-h4
                  grey--text
                  text--lighten-1
                  font-weight-bold
                "
              >
                Descrição
              </div>
              <div
                class="grey--text text--lighten-2 text-body-2 mt-3 mt-md-4"
                v-html="item.text"
              ></div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-sheet>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";

const _config = {
  path: "/produtos",
  mod: "products",
};

export default {
  data: () => ({
    loading: true,
    item: {},
    images: [],
    imgHighlight: "",
    hooperSettings: {
      itemsToShow: 3,
      vertical: false,
      breakpoints: {
        360: {
          itemsToShow: 4,
          vertical: false,
        },
        450: {
          itemsToShow: 5,
          vertical: false,
        },
        600: {
          itemsToShow: 3,
          vertical: false,
        },
        700: {
          itemsToShow: 4,
          vertical: false,
        },
        960: {
          itemsToShow: 4,
          vertical: true,
        },
        1200: {
          itemsToShow: 5,
          vertical: true,
        },
      },
    },
  }),
  computed: {
    whatsapp() {
      return this.$rest("informations-contacts").item.whatsapp_shop;
    },
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .then((data) => {
          this.item = data;

          this.imgHighlight = this.files + data.img.featured.path;

          this.images = data.img.list.map(({ path }) => {
            return path ? this.files + path : "";
          });

          this.loading = false;
        })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.get();
    },
  },
  created() {
    this.get();
  },
  mounted() {
    this.$rest("informations-contacts").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    Loading,
    Title,
    Hooper,
    Slide,
  },
};
</script>

<style lang="scss" scoped>
.item-image-highlight {
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.15) !important;
  padding: 20px;
  width: 100%;
}
.item-images {
  display: grid;
  grid-template-columns: auto 100px;
  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
  }
  .item-image {
    max-height: 80px;
    max-width: 80px;
    object-fit: contain;
    -o-object-fit: contain;
    object-position: center;
    -o-object-position: center;
    width: 100%;
  }
}
.item-text {
  border: 1px solid #dddddd;
}
</style>

<style lang="scss">
.item-image-highlight {
  .normal {
    aspect-ratio: 1 / 1;
    display: block;
    object-fit: contain;
    -o-object-fit: contain;
    width: 100%;
  }
}
.carousel-product-item {
  height: 100%;
  width: 100%;
}
</style>
